export default __webpack_public_path__ + "static/media/past.377258cd.svg";